"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconComponent = _interopRequireDefault(require("./utils/IconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function LandingPlane(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react["default"].createElement(_IconComponent["default"], _extends({
    name: "landing-plane",
    size: "".concat(size),
    viewboxSize: "512"
  }, props), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M54.259 108.393L466.9 266.79c25.265 9.698 37.884 38.041 28.186 63.306-9.698 25.264-38.041 37.883-63.306 28.185L19.14 199.884l35.12-91.491z",
    fill: "#FFF"
  }), _react["default"].createElement("path", {
    d: "M447.509 372.276c-7.743 0-15.502-1.414-22.957-4.25l-75.697-28.802c-7.305-2.779-10.973-10.954-8.193-18.258 2.779-7.303 10.957-10.97 18.258-8.193l75.697 28.802c9.033 3.437 18.863 3.151 27.679-.807 8.816-3.957 15.565-11.11 19.002-20.143 3.436-9.033 3.15-18.862-.807-27.679-3.957-8.818-11.11-15.565-20.141-19.002l-392-149.15-34.186 64.411 222.471 84.647c7.305 2.78 10.973 10.954 8.193 18.258-2.779 7.305-10.953 10.974-18.258 8.193L9.118 209.957a14.148 14.148 0 01-8.213-8.246 14.158 14.158 0 01.746-11.615l47.557-89.606a14.148 14.148 0 0117.532-6.592l403.674 153.595c16.097 6.125 28.847 18.151 35.898 33.866 7.051 15.713 7.562 33.234 1.436 49.33-6.125 16.097-18.151 28.847-33.866 35.898-8.435 3.79-17.394 5.69-26.373 5.69",
    fill: "#1436B8"
  }), _react["default"].createElement("path", {
    fill: "#2CD5C4",
    d: "M127.394 84.955L77.922 66.131 14.566 197.178l96.261 36.627z"
  }), _react["default"].createElement("path", {
    d: "M33.61 188.995l64.758 24.641 13.333-119.799-27.1-10.312-50.992 105.47zm76.801 58.515c-1.7 0-3.403-.306-5.032-.925L9.12 209.957a14.149 14.149 0 01-7.708-19.384L64.767 59.527c3.194-6.609 10.912-9.676 17.772-7.067l49.472 18.824a14.148 14.148 0 019.031 14.791l-16.567 148.85a14.15 14.15 0 01-14.064 12.585z",
    fill: "#1436B8"
  }), _react["default"].createElement("path", {
    fill: "#2CD5C4",
    d: "M248.86 58.911l-62.447-23.76 62.874 184.555 128.892 49.042z"
  }), _react["default"].createElement("path", {
    d: "M260.536 208.845l83.74 31.862-104.94-170.28-29.82-11.346 51.02 149.764zm117.64 74.055a14.11 14.11 0 01-5.029-.926l-128.892-49.042a14.156 14.156 0 01-8.363-8.663L173.018 39.714a14.151 14.151 0 0118.427-17.789l62.447 23.76a14.143 14.143 0 017.015 5.802l129.32 209.838a14.153 14.153 0 01-12.05 21.575zM385.837 490.637H29.407c-7.817 0-14.152-6.335-14.152-14.15 0-7.817 6.335-14.152 14.151-14.152h356.431c7.816 0 14.151 6.335 14.151 14.151s-6.335 14.151-14.15 14.151M483.403 490.637h-31.485c-7.816 0-14.15-6.335-14.15-14.15 0-7.817 6.334-14.152 14.15-14.152h31.485c7.816 0 14.151 6.335 14.151 14.151s-6.336 14.151-14.15 14.151",
    fill: "#1436B8"
  }))));
}

LandingPlane.defaultProps = {
  size: 30
};
var _default = LandingPlane;
exports["default"] = _default;